import { Typography } from "@platform/design-system";

function RequiredTypography({ children, isRequired = false, ...props }) {
  return (
    <Typography {...props}>
      {children}
      {isRequired && (
        <Typography component="span" color="danger">
          {` *`}
        </Typography>
      )}
    </Typography>
  );
}

export default RequiredTypography;
